export default class {
    onCreate() {
        this.state = {
            active: false
        };
    }
    toggleInputDisplay() {
        this.state.active = !this.state.active;
    }
}
